/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TradeImportLogDto,
    TradeImportLogDtoFromJSON,
    TradeImportLogDtoFromJSONTyped,
    TradeImportLogDtoToJSON,
} from './TradeImportLogDto';

/**
 * 
 * @export
 * @interface TradeImportLogListDto
 */
export interface TradeImportLogListDto {
    /**
     * 
     * @type {number}
     * @memberof TradeImportLogListDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof TradeImportLogListDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof TradeImportLogListDto
     */
    offset: number;
    /**
     * 
     * @type {Array<TradeImportLogDto>}
     * @memberof TradeImportLogListDto
     */
    items: Array<TradeImportLogDto>;
}

export function TradeImportLogListDtoFromJSON(json: any): TradeImportLogListDto {
    return TradeImportLogListDtoFromJSONTyped(json, false);
}

export function TradeImportLogListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeImportLogListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(TradeImportLogDtoFromJSON)),
    };
}

export function TradeImportLogListDtoToJSON(value?: TradeImportLogListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(TradeImportLogDtoToJSON)),
    };
}

